<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { loadScript } from "vue-plugin-load-script";

export default {
  name: "App",

  computed: {
    ...mapState("authTracking", ["authVersion", "authMethod"])
  },

  watch: {
    authVersion(newValue) {
      this.$gtag.set({ auth_version: newValue });
    },
    authMethod(newValue) {
      this.$gtag.set({ auth_method: newValue });
    },
    $route (to, from) {
        const zendeskScriptId = "ze-snippet"
        try {
            if (to.path === "/") {
                const zendeskScript = document.createElement("script");
                zendeskScript.type = "text/javascript"
                zendeskScript.id = "ze-snippet"
                zendeskScript.async = true;
                zendeskScript.src = `https://static.zdassets.com/ekr/snippet.js?key=79153e87-9fb2-4b90-bbd8-7c89136b7238?entropy=${new Date().getTime()}`
                document.body.appendChild(zendeskScript)
            } else {
                document.getElementById(zendeskScriptId).remove();
                document.querySelector("iframe[data-product='web_widget']").nextSibling.remove();
                delete window.zE;
                delete window.zEmbed;
                delete window.zEACLoaded;
                document.querySelectorAll('iframe[data-product]').forEach((iframe) => iframe.remove());
                document.querySelectorAll('script[src*="zdassets.com"], script[src*="zopim.com"]').forEach((s) => s.remove());
                delete window.zEQueue;
                delete window.$zopim;
            }
        } catch (err) {
            console.error(err);
        }

        try {
            if (to.path.includes("raffle")) {
                _m();
            }
        } catch (err) {
            console.error("Failed to call React Instant Script, perhaps entrypoint changed?", err);
        }
    }
  },

  created() {
    loadScript("https://raffolux-static.s3.eu-west-2.amazonaws.com/index.js?v=5");
    // Initialize auth tracking from local storage
    this.trackAuthInit();
    
    // Set initial values
    this.$gtag.set({
      auth_version: this.authVersion,
      auth_method: this.authMethod
    });
  },

  methods: {
    ...mapActions("authTracking", ["trackAuthInit"])
  }
};
</script>
